// extracted by mini-css-extract-plugin
module.exports = {"PageContentBlock":"_2UxaOmlqfTfpfH6mETgrhS","AlternateBackground":"_3GvEVIhdLhI-zuGZXi5Xcv","Children":"_3FY7QXSZ0xg5IjvtDJ2fkV"};